import React from "react";

const ConfirmationModal = ({ message, onClick, value }) => {
  const handleNoClick = () => {
    onClick(!value);
  };

  const handleYesClick = () => {
    onClick(!value);
    window.location.href = process.env.REACT_APP_WEBFLOW_HOME_LINK;
  };

  return (
    <div className="fixed z-10 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block md:p-0">
        <div className="fixed inset-0 transition-opacity">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <span className="hidden md:inline-block md:align-middle md:h-screen"></span>
        <div className=" inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all md:my-8 md:align-middle md:max-w-lg md:w-full">
          <div className="bg-white-700 px-4 pt-5 pb-4 md:p-6 md:pb-4">
            <div className="md:flex md:items-start justify-center">
              <div className="mt-3 text-center md:mt-0 md:ml-4 md:text-left">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                  {message}
                </h3>
              </div>
            </div>
          </div>
          <div className="bg-white-700 px-4 py-3 md:px-6 flex md:flex-row flex-rowjustify-center pb-10">
            <div div className="flex flex-row  w-1/2 justify-center">
              <button
                onClick={handleNoClick}
                type="button"
                className="mt-3 inline-flex justify-center rounded-full border border-gray-300 shadow-sm md:px-8 px-10 py-2 bg-gray-500 text-base font-medium text-white-700 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-700 md:mt-0 md:ml-3 md:w-auto md:text-sm"
              >
                No
              </button>
            </div>
            <div className="flex flex-row w-1/2 justify-center">
              <button
                onClick={handleYesClick}
                type="button"
                className="mt-3 inline-flex justify-center rounded-full border border-gray-300 shadow-sm md:px-8 px-8 py-2 bg-blue-500 text-base font-medium text-white-700 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-700 md:mt-0 md:ml-3 md:w-auto md:text-sm"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
